import { EditorState, convertToRaw, convertFromRaw, Modifier } from "draft-js";

const applyFontStyle = (editorState, fontStyle, buttonType) => {
  if (!(fontStyle.startsWith("FONT") && editorState instanceof EditorState))
    return editorState;

  const currentContent = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    let currentInlineStyle = editorState.getCurrentInlineStyle();

    // REMOVE OLD
    currentInlineStyle = currentInlineStyle.filter(
      style => style && style.split("_")[0] !== buttonType,
    );
    const updatedEditorState = EditorState.setInlineStyleOverride(
      editorState,
      currentInlineStyle.add(fontStyle),
    );
    return updatedEditorState;
  }

  const startKey = selectionState.getStartKey();
  const endKey = selectionState.getEndKey();
  const startOffset = selectionState.getStartOffset();
  const endOffset = selectionState.getEndOffset();

  const rawState = convertToRaw(currentContent);

  const { blocks, entityMap } = rawState;
  const startIndex = blocks.findIndex(block => block.key === startKey);
  const endIndex = blocks.findIndex(block => block.key === endKey);

  for (let index = startIndex; index <= endIndex; index += 1) {
    const block = blocks[index];
    const { text, key, inlineStyleRanges } = block;
    const startPoint = key === startKey ? startOffset : 0;
    const endPoint = key === endKey ? endOffset : text.length;
    const updatedStylesRanges = [];

    inlineStyleRanges.forEach(range => {
      const { offset, length, style } = range;
      // check if the style is a string
      if (
        (typeof style === "string" &&
          style.split("_")[0] !== fontStyle.split("_")[0]) ||
        (Array.isArray(style) &&
          style.findIndex(s => s.split("_")[0] === fontStyle.split("_")[0]) ===
            -1) ||
        offset > endPoint ||
        offset + length < startPoint
      ) {
        updatedStylesRanges.push(range);
      } else {
        if (startPoint > offset) {
          updatedStylesRanges.push({
            offset,
            length: startPoint - offset,
            style,
          });
        }
        if (offset + length > endPoint) {
          updatedStylesRanges.push({
            offset: endPoint,
            length: offset + length - endPoint,
            style,
          });
        }
      }
    });

    updatedStylesRanges.push({
      offset: startPoint,
      length: endPoint - startPoint,
      style: fontStyle,
    });

    blocks[index] = {
      ...block,
      inlineStyleRanges: updatedStylesRanges,
    };
  }
  let updatedContentState = convertFromRaw({ blocks, entityMap });
  updatedContentState = Modifier.applyInlineStyle(
    updatedContentState,
    selectionState,
    fontStyle,
  );

  const updatedEditorState = EditorState.push(
    editorState,
    updatedContentState,
    "change-inline-style",
  );
  return updatedEditorState;
};

export default applyFontStyle;
